import React from "react";
import { isIE, isSafari } from 'react-device-detect';
import { injectIntl } from "react-intl";
import MediaQuery from 'react-responsive';
import * as paths from '@app/constants/paths';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// core components
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";

import PromoCard from "@app/components/CustomCards/PromoCard";
// IMG
import blog from "@app/assets/img/icons/blog.svg";
import voucher from "@app/assets/img/icons/voucher.svg";
import score from "@app/assets/img/icons/score.svg";

import promosStyle from "@app/assets/jss/material-kit-pro-react/views/landingPageSections/promosStyle";

const Promos = props => {
    const { classes } = props;

    const blogTitle = props.intl.formatMessage({ id: "blog" });
    const blogDescription = props.intl.formatMessage({ id: "read.latest.blog.posts" });
    const blogLinkText = props.intl.formatMessage({ id: "go.to.blog" });
    const voucherTitle = props.intl.formatMessage({ id: "leo.voucher" });
    const voucherDescription = props.intl.formatMessage({ id: "leo.voucher.quote.help" });
    const voucherQuoteLinkText = props.intl.formatMessage({ id: "quote" });
    const voucherHelpLinkText = props.intl.formatMessage({ id: "help" });
    const opsTitle = props.intl.formatMessage({ id: "op.score" });
    const opsDescription = props.intl.formatMessage({ id: "find.out.your.ops" });
    const opsLinkText = props.intl.formatMessage({ id: "get.your.score" });

    return (
        <div className={classes.container}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                    <PromoCard
                        icon={blog}
                        title={blogTitle}
                        description={blogDescription}
                        links={[
                            {
                                to: paths.BLOG,
                                text: blogLinkText
                            }
                        ]}
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                    <PromoCard
                        icon={voucher}
                        title={voucherTitle}
                        description={voucherDescription}
                        links={[
                            {
                                to: paths.HELPER_T_O_V_S_QUOTE,
                                text: voucherQuoteLinkText
                            },
                            {
                                to: paths.HELPER_T_O_V_S,
                                text: voucherHelpLinkText
                            }
                        ]}
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={4} className={classes.mrAuto}>
                    <PromoCard
                        icon={score}
                        title={opsTitle}
                        description={opsDescription}
                        links={[
                            {
                                to: paths.TOOL_O_P_S,
                                text: opsLinkText
                            }
                        ]}
                    />
                </GridItem>
            </GridContainer>
        </div>
        );
    }
    
export default injectIntl(withStyles(promosStyle)(Promos));